import { Injectable } from "@angular/core";
import { BaseService } from "../services/base.service";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "../tinea-components/okta/auth/auth.service";
import { Observable } from "rxjs";
import { ExternalApiMonitoringList } from "src/swagger-gen/web-secured/models";
import { environment } from "src/environments/environment";
import { GetExternalApisMonitoring$Params } from "src/swagger-gen/web-secured/fn/external-ap-is-monitoring/get-external-apis-monitoring";

@Injectable({
  providedIn: "root",
})
export class MonitoringRepo extends BaseService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    public authService: AuthService
  ) {
    super();
  }

  getProviderConnectivities(
    params: GetExternalApisMonitoring$Params
  ): Observable<ExternalApiMonitoringList> {
    const requestUrl = `${this.baseUrl}/external-apis/monitoring`;

    const httpParams = {
      ...(params.offset !== null && params.offset !== undefined && { offset: params.offset.toString() }),
      ...(params.limit !== null && params.limit !== undefined && { limit: params.limit.toString() }),
    };

    return this.http.get<ExternalApiMonitoringList>(requestUrl, {
      headers: this.httpHeaders(),
      params: httpParams,
    });
  }
}
